import axios from "axios";
import { Message } from "element-ui";
import store from "../store";
import api from "../../static/config/api";
import param from "../../static/config/param";
export function getHeaders(Content_Type) {
  let language = store.state.language;
  let token = store.state.token;

  let headers = {
    "Content-Type": Content_Type,
    projectid: param.projectid,
  };
  if (language != "") {
    headers.language = language;
  }
  if (token != "") {
    headers.authorization = token;
  }
  return headers;
}
let baseURL;
baseURL = Glob.BASE_API;
export function post(url, params) {
  let headers = getHeaders("application/json");
  return new Promise((resolve, reject) => {
    const instance = axios.create({
      baseURL: baseURL,
      timeout: 10000, // 超时
      headers: headers,
    });
    instance
      .post(url, params)
      .then((response) => {
        const res = response.data;
        resolve(res);
      })
      .catch((error) => {
        reject(error);
        //错误提示
        if (error.response) {
          Message.error(error.response.data.message);
        }
      });
  });
}

export function put(url, params) {
  let headers = getHeaders("application/json");
  return new Promise((resolve, reject) => {
    const instance = axios.create({
      baseURL: baseURL,
      timeout: 10000, // 超时
      headers: headers,
    });
    instance
      .put(url, params)
      .then((response) => {
        const res = response.data;
        resolve(res);
      })
      .catch((error) => {
        reject(error);
        //错误提示
        if (error.response) {
          Message.error(error.response.data.message);
        }
      });
  });
}

export function get(url, params) {
  let headers = getHeaders("application/x-www-form-urlencoded");
  return new Promise((resolve, reject) => {
    const instance = axios.create({
      baseURL: baseURL,
      timeout: 25000, // 超时
      headers: headers,
      transformRequest: [
        function(data) {
          // Do whatever you want to transform the data
          let ret = "";
          for (let it in data) {
            ret +=
              encodeURIComponent(it) + "=" + encodeURIComponent(data[it]) + "&";
          }
          return ret;
        },
      ],
    });
    instance
      .get(url, { params })
      .then((response) => {
        const res = response.data;
        resolve(res);
      })
      .catch((error) => {
        reject(error);
        //错误提示
        if (error.response) {
          Message.error(error.response.data.message);
        }
      });
  });
}

export function toDelete(url, params) {
  let headers = getHeaders("application/json");
  return new Promise((resolve, reject) => {
    const instance = axios.create({
      baseURL: baseURL,
      timeout: 10000, // 超时
      headers: headers,
    });
    instance
      .delete(url, { data: params })
      .then((response) => {
        const res = response.data;
        resolve(res);
      })
      .catch((error) => {
        reject(error);
        //错误提示
        if (error.response) {
          Message.error(error.response.data.message);
        }
      });
  });
}



// WEBPACK FOOTER //
// ./src/utils/fetch.js